import { useId } from 'react';
import { VehicleRangeSlider, type VehicleRangeSliderProps } from './VehicleRangeSlider';

type VehicleRangeFilterProps = VehicleRangeSliderProps & {
    /** The selection as text, e.g. „5.000 – 30.000 €“. */
    valueLabel: string;
    startLabel: string;
    endLabel: string;
};

/** A „von – bis“ slider with the selection above and the ends of the scale below. */
export function VehicleRangeFilter({ valueLabel, startLabel, endLabel, ...slider }: VehicleRangeFilterProps) {
    const legendId = useId();

    return (
        <fieldset className="vehicle-filter__group" aria-labelledby={legendId}>
            <div className="vehicle-filter__range-head">
                <span id={legendId} className="vehicle-filter__legend label-xs">
                    {slider.legend}
                </span>
                <span className="vehicle-filter__range-value label-xs" aria-hidden="true">
                    {valueLabel}
                </span>
            </div>

            <VehicleRangeSlider {...slider} />

            <div className="vehicle-filter__range-scale text-xs" aria-hidden="true">
                <span>{startLabel}</span>
                <span>{endLabel}</span>
            </div>
        </fieldset>
    );
}
